import { render } from "./ChatAdApplicationsView.vue?vue&type=template&id=2b024402&scoped=true"
import script from "./ChatAdApplicationsView.vue?vue&type=script&lang=js"
export * from "./ChatAdApplicationsView.vue?vue&type=script&lang=js"

import "./ChatAdApplicationsView.vue?vue&type=style&index=0&id=2b024402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b024402"]])

export default __exports__